import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class UserVerificationService {

  constructor(private httpClient: HttpClient) { }

  verifyUser(userId: string, userAccessToken: string) {
    const params = new HttpParams().set('uid', userId).append('token', userAccessToken);
    return this.httpClient.get('users/confirm', { params: params });
  }

  changePassword(accessToken: string, changePassword: FormData) {
    const params: HttpParams = new HttpParams().set(
      'access_token',
      accessToken
    );
    return this.httpClient.post('/users/change-password', changePassword, {
      params: params
    });
  }

  sendOtp(email: string, otpMethod: string, functionType: string) {
    const params = new HttpParams()
      .set('email', email)
      .append('type', otpMethod)
      .append('functionType', functionType);
    return this.httpClient.get('users/send-otp', { params: params });
  }

  verifyUserByMobile(otp: string, email: string) {
    const params: HttpParams = new HttpParams()
      .set('otp', otp)
      .append('email', email);
    return this.httpClient.get('users/verify-otp', { params: params });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user-verification.service.ts